import axios from "axios";

export interface TabUserResponse {
  companyLocationId: string;
  companyId: string;
  userId: string;
  firstName: string;
  lastName: string;
  userName: string;
  userPhoto: string;
  userLocationPin: string;
  wage: number;
  wageType: number;
  wageTypeName: string;
  userRole: number;
  userRoleName: string;
  isDeleted: boolean;
}

export interface TabUser {
  userId: string;
  userName?: string;
  password?: string;
  companyId?: string;
}

export async function getCompanyLocationTabUser(
  LocationId: string,
  CompanyId: string,
) {
  return axios
    .get<TabUserResponse>(`CompanyLocationUsers/getcompanylocationtabuser`, {
      params: { LocationId, CompanyId },
    })
    .then((res) => res.data);
}

export async function updateTabUser(user: TabUser) {
  return axios.put<{ message: string }>(`/Users/updatetabuser`, user);
}
